// extracted by css-extract-rspack-plugin
export default {"list":"cUjBk","tab":"TFfdZ","tabLabel":"gVPoj","tabSection":"rtseM"};